import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

export default function NewsPhotosSlider() {
  const NewsPhotosSlider = new Swiper('.news-photos-slider .swiper', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    preloadImages: false,
    draggable: true,
    rewind: true,
    navigation: {
      nextEl: '.news-photos-slider__button-next',
      prevEl: '.news-photos-slider__button-prev',
    },
    pagination: {
      el: '.news-photos-slider .swiper-pagination',
      clickable: true,
      renderBullet: (index, className) => `<div class="pagination-dot ${className}"></div>`,
      enabled: true,
    },
    autoplay: {
      enabled: true,
      delay: 6000,
      disableOnInteraction: false,
    },
  });
}
